import type { ReactNode } from "react"
import { cn } from "../../lib/cn"

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-sm px-lg py-3xl text-center", className)}>
      {icon && <div className="mb-xs text-text-secondary">{icon}</div>}
      <p className="text-subtitle font-bold text-text-primary">{title}</p>
      {description && <p className="max-w-[384px] text-body-sm text-text-secondary">{description}</p>}
      {action && <div className="mt-sm">{action}</div>}
    </div>
  )
}
